<script setup lang="ts">
withDefaults(
  defineProps<{
    technologies?: string[];
  }>(),
  {
    technologies: () => [
      "Nuxt",
      "React",
      "Laravel",
      "Vue",
      "Node.js",
      "TypeScript",
      "Tailwind CSS",
      "PrimeVue",
      "Pinia",
      "LLM KB",
      "VaahAgents",
      "GenicUI",
      "Agentic AI",
      "RAG",
      "MCP",
      "LangChain",
      "LangGraph",
      "CrewAI",
      "AutoGen",
      "Pinecone",
      "Ollama",
      "vLLM",
      "PyTorch",
    ],
  },
);
const marqueeClasses =
  "marquee overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_12%,black_88%,transparent)]";
</script>
<template>
  <section class="relative">
    <Reveal
      :append-class="marqueeClasses"
    >
      <div class="marquee-track flex w-max items-center gap-8 pr-8">
        <!-- first copy: the real list, read by assistive tech -->
        <div class="flex items-center gap-8">
          <template v-for="(tech, index) in technologies" :key="index">
            <span
              class="text-lg font-medium tracking-[0.5px] whitespace-nowrap"
            >
              {{ tech }}
            </span>
            <span class="size-1.5 rounded-full bg-[#BA55FE] shrink-0" aria-hidden="true"></span>
          </template>
        </div>
        <!-- second copy: visual clone for the seamless loop, hidden from AT -->
        <div class="flex items-center gap-8" aria-hidden="true">
          <template v-for="(tech, index) in technologies" :key="index">
            <span
              class="text-lg font-medium tracking-[0.5px] whitespace-nowrap"
            >
              {{ tech }}
            </span>
            <span class="size-1.5 rounded-full bg-[#BA55FE] shrink-0" aria-hidden="true"></span>
          </template>
        </div>
      </div>
    </Reveal>
  </section>
</template>
<style scoped>
.marquee-track {
  animation: marquee 32s linear infinite;
  will-change: transform;
  backface-visibility: hidden;
}
.marquee:hover .marquee-track {
  animation-play-state: paused;
}
@keyframes marquee {
  to {
    transform: translateX(-50%);
  }
}
</style>
